var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShoppingB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#003d85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.875,37.625,33.75,26.25h2.625v2.625h.875V26.25h3.5v2.625h.875V26.25H44.25l.875,11.375Zm4.375-14a1.75,1.75,0,0,1,3.5,0v1.75h-3.5Zm7.875,1.75h-3.5v-1.75a2.625,2.625,0,0,0-5.25,0v1.75h-3.5L32,38.5H46Z",
    transform: "translate(-25 -16.406)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingB);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'%3e%3ccircle cx='14' cy='14' r='14' fill='%23003d85'/%3e%3cpath d='M32.875,37.625,33.75,26.25h2.625v2.625h.875V26.25h3.5v2.625h.875V26.25H44.25l.875,11.375Zm4.375-14a1.75,1.75,0,0,1,3.5,0v1.75h-3.5Zm7.875,1.75h-3.5v-1.75a2.625,2.625,0,0,0-5.25,0v1.75h-3.5L32,38.5H46Z' transform='translate(-25 -16.406)' fill='%23fff'/%3e%3c/svg%3e";
export { ForwardRef as ReactComponent };